var $page = $page || {};
var $pages = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  historyUse: true,
  historyHome: 'home',

  timeLoaderDelay: 500,
  timeLoaderFadeIn: 300,
  timeLoaderFadeOut: 300,

  timeTransitionDelay: 100,
  timeTransitionVertical: 1000,
  timeTransitionHorizontal: 700,

  hideHeroAfterLandingPage: false,

  easeTransition: Power2.easeInOut,

  // ======================================================================
  // VARS
  // ======================================================================

  prevPage: null,
  currentPage: null,
  offsetPercent: 0,
  ajaxData: null,
  ajaxLoaderTimeout: null,

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    $pages.historyInit();
    // get active page
    var page = $('.page--current').first();
    var pageId = page.attr('id').replace('page-', '');
    $pages.currentPage = pageId;
    // set styles
    $pages.renderStyles();
    // set active scroll page
    $scroll.setPage('page-' + $pages.currentPage);
    // hijax
    $hijax.init();
  },

  // ======================================================================
  // SHOW PAGE
  // ======================================================================

  show: function(page, direction, pushit) {
    var pageId = $pages.pathToId(page);
    console.log('%c--- page - ' + pageId + ' ---', 'color:#E1BF97;');
    // CHECK IF NEW PAGE IS SAME AS CURRENT PAGE
    if ($pages.currentPage != pageId) {
      // CHECK PAGE EXISTS
      if ($('#page-' + pageId).length > 0) {
        $pages.render(page, pageId, direction, pushit);
      } else {
        $pages.ajax(page, pageId, direction, pushit);
      }
    } else {
      // NEW PAGE IS SAME AS PREV PAGE, JUST HIDE NAV
      $nav.hide();
    }
  },

  // ======================================================================
  // AJAX PAGE - IF NOT ALREADY PRELOADED
  // ======================================================================

  ajax: function(page, pageId, direction, pushit) {
    // DISABLE THINGS
    $scroll.disable();
    $utils.blocker.show();
    // SAVE DATA
    $pages.ajaxData = {
      page: page,
      pageId: pageId,
      direction: direction,
      pushit: pushit
    };
    // SHOW LOADER
    $pages.ajaxLoaderShow();
    // AJAX
    $hijax.loadPage(page, $pages.ajaxCallback);
  },

  ajaxCallback: function() {
    // HIDE LOADER
    $pages.ajaxLoaderHide();
    // RENDER PAGE
    setTimeout(function() {
      $pages.render($pages.ajaxData.page, $pages.ajaxData.pageId, $pages.ajaxData.direction, $pages.ajaxData.pushit);
    }, $pages.timeLoaderFadeOut);
  },

  ajaxLoaderShow: function() {
    clearTimeout($pages.ajaxLoaderTimeout);
    $pages.ajaxLoaderTimeout = setTimeout(function() {
      $el('#load-blocker')
        .stop(true, true)
        .css({opacity: 0})
        .show()
        .fadeTo($pages.timeLoaderFadeIn, 0.9);
    }, $pages.timeLoaderDelay);
  },

  ajaxLoaderHide: function() {
    clearTimeout($pages.ajaxLoaderTimeout);
    $el('#load-blocker')
      .stop(true, true)
      .fadeOut($pages.timeLoaderFadeOut);
  },

  // ======================================================================
  // RENDER PAGE
  // ======================================================================

  render: function(page, pageId, direction, pushit) {
    // STORE PAGE
    $pages.prevPage = $pages.currentPage;
    $pages.currentPage = pageId;

    // HISTORY
    if (pushit !== false) {
      $pages.historyPush(page);
    }

    // IDs
    var prevId = 'page-' + $pages.prevPage;
    var currentId = 'page-' + $pages.currentPage;

    // DISABLE THINGS
    $scroll.disable();
    $utils.blocker.show();
    $videos.pauseAll();

    // ELEMENTS
    var prevElement = $('#' + prevId);
    var currentElement = $('#' + currentId);

    // CHECK PAGE RELATIONSHIP
    var prevParent = prevElement.attr('data-parent');
    var currentParent = currentElement.attr('data-parent');

    // DIRECTION
    if (typeof direction !== 'string') {
      if (currentParent === $pages.prevPage) {
        direction = 'parent_to_child';
        $pages.offsetPercent += 100;
      } else if (typeof currentParent !== 'undefined' && currentParent === prevParent) {
        direction = 'child_to_child';
        $pages.offsetPercent += 100;
      } else if (prevParent === $pages.currentPage) {
        direction = 'child_to_parent';
        $pages.offsetPercent -= 100;
      } else if (!$nav.visible) {
        direction = 'parent_to_parent';
        $pages.offsetPercent += 100;
      } else {
        direction = 'parent_to_parent_nav';
      }
    }

    // TITLE
    var title = currentElement.attr('data-title');
    if (typeof title !== 'undefined' && title != '') {
      $el('title').text(title);
    } else {
      $el('title').text('Matter');
    }

    // LAZY LOAD MEDIA
    var media = currentElement.find('img, video');
    media.each(function() {
      var src = $(this).attr('data-src');
      var srcset = $(this).attr('data-srcset');
      if (srcset !== '' && typeof srcset !== 'undefined') {
        $(this).attr('srcset', srcset);
      }
      if (src !== '' && typeof src !== 'undefined') {
        $(this).attr('src', src);
      }
    });

    // ANALYTICS
    $analytics.google.page($pages.pathToHistoryUrl(page));

    // CLASSES
    $('.page--prev').removeClass('page--prev');
    prevElement.addClass('page--prev').removeClass('page--current');
    currentElement
      // .css($windowsize.isDesktop ? {top: $pages.offsetPercent + '%'} : {left: $pages.offsetPercent + '%'})
      .addClass('page--current');

    // PAGE POSITION
    gsap.set(
      currentElement,
      $windowsize.isDesktop
        ? {
            xPercent: 0,
            yPercent: $pages.offsetPercent
          }
        : {
            xPercent: $pages.offsetPercent,
            yPercent: 0
          }
    );

    // RESIZING
    $windowsize.resizeNewPage();

    // TRANSITION
    if ($windowsize.isDesktop) {
      $pages.renderTransitionDesktop(direction, currentId, prevParent);
    } else {
      $pages.renderTransitionMobile(direction, currentId, prevParent);
    }

    // ENABLE THINGS - CALCULATE DELAY
    var enableDelay;
    if (direction === 'parent_to_parent_nav') {
      if ($windowsize.isDesktop) {
        enableDelay = $nav.timeOpen + $nav.timeWipe + 100;
      } else {
        enableDelay = $nav.timeOpen;
      }
    } else {
      if ($windowsize.isDesktop) {
        enableDelay = $pages.timeTransitionVertical;
      } else {
        enableDelay = $pages.timeTransitionHorizontal;
      }
    }

    // ENABLE THINGS
    setTimeout(function() {
      $scroll.setNewPage(currentId);
      $animate.setNewPage();
      $utils.blocker.hide();
      $hijax.loadPageLinks();
    }, enableDelay);
  },

  // ======================================================================
  // RENDER TRANSITION - DESKTOP
  // ======================================================================

  renderTransitionDesktop: function(direction, currentId, prevParent) {
    // NAV WIPE
    if (direction === 'parent_to_parent_nav') {
      // reset new page scroll position
      $scroll.resetPageScrollPos(currentId);
      // animation 1 - nav covers old page
      $nav.wipeRight();
      // animation 2 - nav reveals new page
      setTimeout(function() {
        if ($pages.hideHeroAfterLandingPage) {
          $('.page--landing').removeClass('page--landing');
        }
        $('.page--prev').removeClass('page--prev');
        $pages.renderStyles();
        $nav.wipeLeft();
      }, $nav.timeOpen + 50);
    }

    // CHILD TO PARENT
    else if (direction === 'child_to_parent') {
      // close nav
      $nav.hide(false, false);
      // reset new page scroll position
      if (prevParent !== $pages.currentPage) {
        $scroll.resetPageScrollPos(currentId);
      }
      // set styles
      $pages.renderStyles();
      // slide up to parent
      setTimeout(function() {
        gsap.to($el('#wrapper'), {
          yPercent: -$pages.offsetPercent,
          duration: $pages.timeTransitionVertical / 1000,
          ease: $pages.easeTransition
        });
      }, $pages.timeTransitionDelay);
    }

    // PARENT TO PARENT / PARENT TO CHILD / CHILD TO CHILD
    else {
      // close nav
      $nav.hide(false, false);
      // reset new page scroll position
      $scroll.resetPageScrollPos(currentId);
      // set styles
      setTimeout(function() {
        $pages.renderStyles();
      }, $pages.timeTransitionVertical * 0.3);
      // slide down to child
      setTimeout(function() {
        gsap.to($el('#wrapper'), {
          yPercent: -$pages.offsetPercent,
          duration: $pages.timeTransitionVertical / 1000,
          ease: $pages.easeTransition
        });
      }, $pages.timeTransitionDelay);
      // remove initial class
      setTimeout(function() {
        if ($pages.hideHeroAfterLandingPage && direction === 'parent_to_parent') {
          $('.page--landing').removeClass('page--landing');
        }
      }, $pages.timeTransitionDelay + $pages.timeTransitionVertical);
    }
  },

  // ======================================================================
  // RENDER TRANSITION - MOBILE
  // ======================================================================

  renderTransitionMobile: function(direction, currentId, prevParent) {
    // NAV WIPE
    if (direction === 'parent_to_parent_nav') {
      // reset new page scroll position
      $scroll.resetPageScrollPos(currentId);
      // remove page classes
      if ($pages.hideHeroAfterLandingPage) {
        $('.page--landing').removeClass('page--landing');
      }
      $('.page--prev').removeClass('page--prev');
      // set styles
      $pages.renderStyles();
      // close nav
      $nav.hide(false, false);
    }

    // CHILD TO PARENT
    else if (direction === 'child_to_parent') {
      // close nav
      $nav.hide(false, false);
      // reset new page scroll position
      if (prevParent !== $pages.currentPage) {
        $scroll.resetPageScrollPos(currentId);
      }
      // set styles
      $pages.renderStyles();
      // slide up to parent
      setTimeout(function() {
        gsap.to($el('#wrapper'), {
          xPercent: -$pages.offsetPercent,
          duration: $pages.timeTransitionHorizontal / 1000,
          ease: $pages.easeTransition
        });
      }, $pages.timeTransitionDelay);
    }

    // PARENT TO PARENT / PARENT TO CHILD / CHILD TO CHILD
    else {
      // close nav
      $nav.hide(false, false);
      // reset new page scroll position
      $scroll.resetPageScrollPos(currentId);
      // set styles
      setTimeout(function() {
        $pages.renderStyles();
      }, $pages.timeTransitionHorizontal * 0.3);
      // slide down to child
      setTimeout(function() {
        gsap.to($el('#wrapper'), {
          xPercent: -$pages.offsetPercent,
          duration: $pages.timeTransitionHorizontal / 1000,
          ease: $pages.easeTransition
        });
      }, $pages.timeTransitionDelay);
      // remove page classes
      setTimeout(function() {
        if ($pages.hideHeroAfterLandingPage && direction === 'parent_to_parent') {
          $('.page--landing').removeClass('page--landing');
        }
      }, $pages.timeTransitionDelay + $pages.timeTransitionHorizontal);
    }
  },

  // ======================================================================
  // RENDER STYLES
  // ======================================================================

  renderStyles: function() {
    // invert colours
    var current = $('.page--current');
    var isInverted = current.hasClass('page--invert');
    if (isInverted) {
      $el('html, body').addClass('js-page-invert');
    } else {
      $el('html, body').removeClass('js-page-invert');
    }
    // project class
    var isProject = current.attr('data-show-close-project');
    if (typeof isProject !== 'undefined') {
      $el('body').addClass('js-is-project');
    } else {
      $el('body').removeClass('js-is-project');
    }
  },

  // ======================================================================
  // RESET PAGE POSITION AFTER RESIZE
  // ======================================================================

  resetAfterResize: function() {
    $pages.offsetPercent = 0;
    gsap.set($el('#wrapper'), {
      xPercent: 0,
      yPercent: 0
    });
    gsap.set($('.page'), {
      xPercent: 0,
      yPercent: 0
    });
    $('.page--prev').removeClass('page--prev');
    // $('.page').attr('style', '');
  },

  // ======================================================================
  // HISTORY / PUSHSTATE
  // ======================================================================

  historyInit: function() {
    if ($pages.historyUse && $device.js.pushState) {
      window.onpopstate = function(e) {
        $pages.historyPop();
      };
    }
  },
  historyPush: function(page) {
    if ($pages.historyUse && $device.js.pushState) {
      page = $pages.pathToHistoryUrl(page);
      history.pushState(
        {}, // data
        document.title, // title
        page // url
      );
    }
  },
  historyPop: function() {
    var page = $pages.pathToHistoryUrl(window.location.pathname);
    if (page != null && page != 'null') {
      // && $('#page-' + page).length > 0) {
      $pages.show(page, null, false);
    }
  },

  // ======================================================================
  // HELPERS
  // ======================================================================

  pathToId: function(path) {
    // create clean id string
    var protocol = window.location.protocol;
    var origin = window.location.origin.replace(protocol, '');
    path = path
      .replace(/ /g, '')
      .replace(protocol, '')
      .replace(origin, '')
      .replace(/\//g, '-');
    // replace start / end dashes
    if (path.charAt(0) === '-') {
      path = path.substr(1);
    }
    if (path.charAt(path.length - 1) === '-') {
      path = path.substr(0, path.length - 1);
    }
    // if empty, set to default id
    if (path === '') {
      path = $pages.historyHome;
    }
    return path;
  },

  pathToHistoryUrl: function(path) {
    // create clean id string
    var protocol = window.location.protocol;
    var origin = window.location.origin.replace(protocol, '');
    path = path
      .replace(/ /g, '')
      .replace(protocol, '')
      .replace(origin, '');
    // add start slash
    if (path.charAt(0) !== '/') {
      path = '/' + path;
    }
    // if default id, set to empty
    if (path === '/' + $pages.historyHome) {
      path = '/';
    }
    return path;
  }
};
